import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CardSectionHeading from '../CardSectionHeading';
import CardRowKeyVal from '../CardRowKeyVal';
import moment from 'moment-timezone';
import get from 'lodash/get';
import map from 'lodash/map';

const propTypes = {
  details: PropTypes.shape({
    additional_insured_coverage: PropTypes.string,
    additional_insureds: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ),
    address: PropTypes.object,
    business_name: PropTypes.string,
    business_personal_property: PropTypes.string,
    data_breach_additional_costs: PropTypes.string,
    data_breach_privacy_liability: PropTypes.string,
    deductible: PropTypes.string,
    employee_liability_coverage: PropTypes.string,
    general_liability: PropTypes.string,
    hired_and_non_owned_auto: PropTypes.string,
    insured: PropTypes.string,
    legal_nature: PropTypes.string,
    lost_business_income: PropTypes.string,
  }),
};

const defaultProps = {
  details: {},
};

class PolicyDetailsCommercial extends PureComponent {

  formatDate(dateStr) {
    return moment(dateStr, 'YYYY-MM-DD').format('MMM DD, YYYY');
  }

  get additionalInsuredsNodes() {
    return map(get(this.props.details, 'additional_insureds'), (additionalInsured, i) => (
      <CardRowKeyVal
        key={i}
        title="Additional insured"
        detail={additionalInsured.name}
      />
    ));
  }

  render() {
    const {
      coverage_start_date,
      coverage_end_date,
      plan,
    } = this.props;
    const {
      additional_insured_coverage,
      address,
      business_personal_property,
      data_breach_privacy_liability,
      data_breach_additional_costs,
      employee_liability_coverage,
      general_liability,
      hired_and_non_owned_auto,
      insured,
      legal_nature,
      lost_business_income,
    } = this.props.details;

    return (
      <div>
        <CardRowKeyVal
          title="Coverage period"
          detail={`From ${this.formatDate(coverage_start_date)} to ${this.formatDate(coverage_end_date)}`}
        />
        <CardRowKeyVal
          title="Primary contact"
          detail={insured}
        />
        {this.additionalInsuredsNodes}
        <CardRowKeyVal
          title="Entity"
          detail={legal_nature}
        />
        <CardSectionHeading>
          Location details
        </CardSectionHeading>
        <CardRowKeyVal
          title="Address"
          detail={
            <div>
              <span>{get(address, 'line1')}</span>
              <br/>
              {get(address, 'line2') && [<span key="line2">{get(address, 'line2')}</span>, <br key="line2br" />]}
              <span>{get(address, 'city')}, {get(address, 'region')} {get(address, 'postal')}</span>
            </div>
          }
        />
        <CardSectionHeading>
          Policy Selections
        </CardSectionHeading>
        <CardRowKeyVal
          title="Plan type"
          detail={get(plan, 'title')}
        />
        <CardRowKeyVal
          title="General liability"
          detail={general_liability}
        />
        <CardRowKeyVal
          title="Business personal property"
          detail={business_personal_property}
        />
        <CardRowKeyVal
          title="Additional insured"
          detail={additional_insured_coverage}
        />
        <CardRowKeyVal
          title="Lost business income"
          detail={lost_business_income}
        />
        <CardRowKeyVal
          title="Data breach privacy liability"
          detail={data_breach_privacy_liability || "Not Added"}
        />
        <CardRowKeyVal
          title="Data breach additional costs"
          detail={data_breach_additional_costs || "Not Added"}
        />
        <CardRowKeyVal
          title="Employee liability coverage"
          detail={employee_liability_coverage || "Not Added"}
        />
        <CardRowKeyVal
          title="Hired and non-owned auto"
          detail={(hired_and_non_owned_auto && "Added") || "Not Added"}
        />
      </div>
    );
  }
}

PolicyDetailsCommercial.propTypes = propTypes;
PolicyDetailsCommercial.defaultProps = defaultProps;

export default PolicyDetailsCommercial;
